import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareAiPlanningClassicRoute: InvariantJiraRoute = {
	name: 'software-ai-planning-classic',
	path: '/jira/software/c/projects/:projectKey/ai-planning',
	exact: true,
};
